var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileDocx = function SvgFileDocx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M7.8.6h8.67c1.103 0 2.162.434 2.948 1.208l7.729 7.609A4.2 4.2 0 0 1 28.4 12.41V27.2a4.2 4.2 0 0 1-4.2 4.2H7.8a4.2 4.2 0 0 1-4.2-4.2V4.8A4.2 4.2 0 0 1 7.8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M18 1v6.8a3.2 3.2 0 0 0 3.2 3.2H28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3981F6",
    d: "M0 17a3 3 0 0 1 3-3h25a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.546 24v-6.318h2.182c1.989 0 3.203 1.232 3.203 3.159S7.717 24 5.728 24zm1.276-1.109h.906c1.223 0 1.918-.81 1.918-2.05 0-1.25-.695-2.05-1.927-2.05h-.897zm4.822-2.05c0-1.91 1.25-3.256 2.992-3.256 1.734 0 2.983 1.346 2.983 3.256s-1.25 3.256-2.983 3.256c-1.742 0-2.992-1.347-2.992-3.256m4.673 0c0-1.294-.695-2.121-1.68-2.121-.995 0-1.69.827-1.69 2.12s.695 2.122 1.69 2.122c.985 0 1.68-.828 1.68-2.121m3.31 0c0 1.285.678 2.12 1.646 2.12.687 0 1.189-.43 1.364-1.135l1.215.405c-.37 1.144-1.259 1.866-2.579 1.866-1.707 0-2.947-1.347-2.947-3.256 0-1.91 1.24-3.256 2.947-3.256 1.32 0 2.21.721 2.579 1.865l-1.215.405c-.175-.704-.677-1.135-1.364-1.135-.968 0-1.645.836-1.645 2.12m10.067-3.16L25.6 20.789 27.79 24h-1.469l-1.496-2.253L23.311 24h-1.416l2.19-3.212-2.111-3.106h1.46l1.418 2.13 1.425-2.13z"
  })));
};
export default SvgFileDocx;